import React from 'react';

export default function Card({
    children,
    title,
    description,
    headerRight,
    className = '',
    bodyClassName = '',
    noPadding = false,
}) {
    const hasHeader = title || headerRight;

    return (
        <div className={`rounded-lg border border-gray-200 bg-white ${className}`}>
            {hasHeader && (
                <div className="flex items-center justify-between px-4 py-3 border-b border-gray-100">
                    <div>
                        {title && <h4 className="text-sm font-medium text-gray-900">{title}</h4>}
                        {description && <p className="text-xs text-gray-500 mt-0.5">{description}</p>}
                    </div>
                    {headerRight && <div className="flex items-center gap-2">{headerRight}</div>}
                </div>
            )}
            <div className={noPadding ? bodyClassName : `p-4 space-y-3 ${bodyClassName}`}>
                {children}
            </div>
        </div>
    );
}
